import image from "../../assets/spotlight/antibiotica.webp";
import Kicker from "../Kicker";

const WelcomeHero = ({ spotlight }) => {
  const FrontEndData = true; // if false the spotlight profile is set within admin view

  const bandUrl = "/music/" + spotlight.band.slug;
  const bandUrlF = "/music/antibiotica";
  const bandName = "Antibiotica";
  const slogan = "Kraftfull och autentisk thrash/heavy metal";

  // If using backend to load spotlight
  if (FrontEndData) {
    return (
      <div className="px-4 max-w-7xl m-auto">
        {/* ── Mobile layout ── */}
        <div className="md:hidden rounded-2xl overflow-hidden border border-white/10 bg-[#131313] shadow-xl">
          <div className="relative aspect-video overflow-hidden">
            <img
              src={image}
              alt={`${bandName}´s splashbild`}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#131313]" />
          </div>
          <div className="px-6 pb-8 pt-4 space-y-3">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#0047ff]/10 border border-[#0047ff]/25 backdrop-blur-md">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#0047ff] opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#0047ff]"></span>
              </span>
              <span className="text-[#0047ff] text-[10px] font-black tracking-[0.2em] uppercase">
                LOKULT SPOTLIGHT
              </span>
            </div>
            <h1 className="text-3xl font-extrabold text-white uppercase tracking-wide leading-tight">
              {bandName}
            </h1>
            <p className="text-sm text-stone-400 leading-relaxed">{slogan}</p>
            <a href={bandUrlF} className="block w-full">
              <button className="btn bg-[#0047ff] hover:bg-blue-700 text-white border-none rounded-full w-full font-bold uppercase tracking-wider text-xs shadow-[0_4px_15px_rgba(0,71,255,0.3)]">
                Utforska
              </button>
            </a>
          </div>
        </div>

        {/* ── Desktop layout ── */}
        <section className="hidden md:flex relative bg-gradient-to-tr from-[#131313] via-transparent to-transparent h-[45em] border border-white/10 rounded-3xl overflow-hidden items-center shadow-2xl">
          <div className="absolute inset-0 -z-10">
            <img
              src={image}
              alt={`${bandName}´s splashbild`}
              className="w-full h-full object-cover object-top filter brightness-95"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#131313] via-[#131313]/30 to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#131313]/60 via-transparent to-transparent" />
          </div>

          <div className="absolute bottom-0 left-0 right-0 z-10 max-w-7xl mx-auto px-12 w-full pb-14">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#0047ff]/10 border border-[#0047ff]/25 mb-4 backdrop-blur-md">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#0047ff] opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#0047ff]"></span>
              </span>
              <span className="text-[#0047ff] text-[10px] font-black tracking-[0.2em] uppercase">
                LOKULT SPOTLIGHT
              </span>
            </div>
            <div className="space-y-2 mb-3">
              <h1 className="text-6xl md:text-8xl font-black text-white uppercase tracking-wider leading-[0.95] drop-shadow-lg">
                {bandName}
              </h1>
            </div>
            <p className="text-lg md:text-xl text-stone-300 font-medium max-w-xl mb-6 leading-relaxed drop-shadow-md">
              {slogan}
            </p>
            <div className="flex flex-wrap gap-4">
              <a href={bandUrlF}>
                <button className="btn bg-[#0047ff] hover:bg-blue-700 text-white border-none rounded-full px-8 py-3.5 font-bold uppercase tracking-wider text-xs shadow-[0_4px_20px_rgba(0,71,255,0.45)] hover:scale-105 transition-all duration-300">
                  Utforska
                </button>
              </a>
            </div>
          </div>
        </section>
      </div>
    );
  } else {
    if (spotlight) {
      return (
        <section className="relative w-full h-[45em] overflow-hidden bg-[#131313] flex items-center border border-white/10 rounded-3xl shadow-2xl">
          {/* Background image with overlay layers */}
          <div className="absolute inset-0 z-0">
            <img
              src={spotlight.band.image_splash}
              alt={`${spotlight.band.name} big splash image as a background`}
              className="w-full h-full object-cover object-top opacity-75"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#131313] via-[#131313]/50 to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#131313] via-transparent to-transparent" />
          </div>

          {/* Content */}
          <div
            className="relative z-10 max-w-7xl mx-auto px-12 w-full pb-14"
          >
            {/* Spotlight Badge */}
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#0047ff]/10 border border-[#0047ff]/25 mb-6 backdrop-blur-md">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#0047ff] opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#0047ff]"></span>
              </span>
              <span className="text-[#0047ff] text-[10px] font-black tracking-[0.2em] uppercase">
                LOKULT SPOTLIGHT
              </span>
            </div>

            {/* Heading */}
            <div className="space-y-2 mb-4">
              <h1 className="text-6xl md:text-8xl font-black text-white uppercase tracking-wider leading-[0.95] drop-shadow-lg">
                {spotlight.band.name}
              </h1>
            </div>

            {/* Description */}
            <p className="text-lg md:text-xl text-stone-300 font-medium max-w-xl mb-6 leading-relaxed drop-shadow-md">
              {spotlight.slogan}
            </p>

            {/* Button */}
            <div className="flex flex-wrap gap-4">
              <a href={bandUrl}>
                <button className="btn bg-[#0047ff] hover:bg-blue-700 text-white border-none rounded-full px-8 py-3.5 font-bold uppercase tracking-wider text-xs shadow-[0_4px_20px_rgba(0,71,255,0.45)] hover:scale-105 transition-all duration-300">
                  Utforska
                </button>
              </a>
            </div>
          </div>
        </section>
      );
    }
  }
};

export default WelcomeHero;
